import { h, Component } from 'preact'
import { EscalatedButton } from './EscalationButtons'

/* eslint-disable import/no-internal-modules */
import { subscribe } from '@insided/deprecated-utils/globals'

type EscalationType = 'zendesk' | 'productboard' | 'salesforce' | 'freshdesk'

interface Props {
  isEnabled: boolean
  imageName: string
  title: string
  id: string
  escalationType: EscalationType
}

interface State {
  url: string| null
}

class OpenEscalationButton extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.setState({
      url: null
    })
  }

  async componentDidMount () {
    if (this.props.escalationType === 'productboard') {
      subscribe('productboard_note_created', (payload) => {
        if (payload.id === this.props.id) {
          this.setState({ url: payload.url })
        }
      })
    }
    if (this.props.escalationType === 'zendesk') {
      subscribe('zendesk_ticket_created', (payload) => {
        if (payload.id === this.props.id) {
          this.setState({ url: payload.url })
        }
      })
    }
    if (this.props.escalationType === 'salesforce') {
      subscribe('salesforce_case_created', (payload) => {
        if (payload.id === this.props.id) {
          this.setState({ url: payload.url })
        }
      })
    }
    if (this.props.escalationType === 'freshdesk') {
      subscribe('freshdesk_ticket_created', (payload) => {
        if (payload.id === this.props.id) {
          this.setState({ url: payload.url })
        }
      })
    }
  }

  render () {
    const { imageName, title, isEnabled, escalationType } = this.props
    const { url } = this.state
    if (!isEnabled) {
      return null
    }
    return (
      <EscalatedButton redirectUrl={url} imageName={imageName} title={title} customClasses={`qa-escalated-link-${escalationType}`} />
    )
  }
}

export default OpenEscalationButton
